import {createStore} from 'vuex'
import auth from './auth'
import administrators from './admin/administrator'

// Office
import office from "@/store/app/office";

// Google
import google from '@/store/app/google'

// Dropbox
import dropbox from '@/store/app/dropbox'

// Box
import box from '@/store/app/box'

// Salesforce
import salesforce from '@/store/app/salesforce'

// EntraId
import entraId from '@/store/app/entraId'

import createPersistedState from "vuex-persistedstate";

const Store = createStore({
  modules: {
    auth,
    administrators,
    office,
    google,
    dropbox,
    box,
    salesforce,
    entraId,
  },
  plugins: [
    createPersistedState({
      key: 'idrive',
      paths: ['auth.accessToken'],
    })
  ],
  mutations: {
    setProviderTenant(state, providerTenant) {
      state.providerTenant = providerTenant

      if (providerTenant === 'GOOGLE') {
        state.providerUrl = 'google';
        state.providerTenantVal = 2;
      } else if (providerTenant === 'DROPBOX') {
        state.providerUrl = 'dropbox';
        state.providerTenantVal = 3;
      } else if (providerTenant === 'BOX') {
        state.providerUrl = 'box';
        state.providerTenantVal = 4;
      } else if (providerTenant === 'SALESFORCE') {
        state.providerUrl = 'salesforce';
        state.providerTenantVal = 5;
      } else if (providerTenant === 'ENTRAID') {
        state.providerUrl = 'entraId';
        state.providerTenantVal = 6;
      } else {
        state.providerUrl = 'office';
        state.providerTenantVal = 1;
      }
    },

    setCollection(state, collection) {
      state.collection = collection;
    }
  },
  state: {
    providerTenant: null,
    providerUrl: null,
    providerTenantVal: null,
    collection: null,
  }
})

export default Store;

export {Store};
